module.exports = __webpack_public_path__ + "static/media/ALL TRIAL if-correct.70859a35.mp3";